import React from "react";

function Comment_post(props) {
    return (
        <div className="comment-post">
            <h2>دیدگاهتان را بنویسید</h2>
            <p>نشانی ایمیل شما منتشر نخواهد شد.</p>
            <form action="" method="post">
                <div className="width-50">
                    <div className="form-item">
                        <label htmlFor="fullname">نام</label>
                        <input type="text" name="fullname" id="fullname" required />
                    </div>
                    <div className="form-item">
                        <label htmlFor="email">ایمیل</label>
                        <input type="email" name="email" id="email" required />
                    </div>
                </div>
                <div className="form-item">
                    <label htmlFor="website">وبسایت</label>
                    <input type="url" name="website" id="website" />
                </div>
                <div className="form-item">
                    <label htmlFor="text">دیدگاه</label>
                    <textarea name="text" id="text" rows="10" required></textarea>
                </div>
                <div className="form-submit">
                    <input type="hidden" name="post-id" value={props.id} />
                    <input type="submit" name="submit-comment" value="ارسال دیدگاه" />
                </div>
            </form>
        </div>
    );
}

export default Comment_post;